import { Box, CloseButton, Spacer } from '@chakra-ui/react'
import { Icon, Tag, Text } from '@chakra-ui/react'
import { FaEnvelope } from 'react-icons/fa'
import React from 'react'
import { FaPhone } from 'react-icons/fa'
import SharedInfoText from '~components/shared/texts/shared-info-text'
import {
    formatEmail,
    getClientFullName,
    getClientSecondaryName,
} from '~utils/helpers'
import { formatPhoneReadable } from '~utils/phone'
import SharedStack from '~components/shared/wrappers/shared-stack'
import {
    ChatClinicFieldsFragment,
    ClientPreviewFieldsFragment,
} from '~graphql/generated/graphql'
import { FiUser } from 'react-icons/fi'
import SharedLabel from '~components/shared/form/shared-label'

export default function ClientPreview({
    clinic,
    client,
    onCancel,
}: {
    clinic: ChatClinicFieldsFragment
    client: ClientPreviewFieldsFragment
    onCancel?: () => void
}) {
    const clientSecondaryName = getClientSecondaryName(client)

    return (
        <SharedStack
            row
            textAlign="left"
            spacing={4}
            bg="brand.50"
            border="1px solid"
            borderColor="brand.500"
            rounded="xl"
            p={4}
        >
            <Icon as={FiUser} boxSize={6} />
            <Box>
                <SharedStack row>
                    <SharedLabel>{getClientFullName(client) || ''}</SharedLabel>
                    {clientSecondaryName && (
                        <Text fontSize="sm" color="gray.500" mb={-1}>
                            {`(secondary: ${clientSecondaryName})`}
                        </Text>
                    )}
                    {!client.is_active && (
                        <Tag size="sm" colorScheme="red">
                            Inactive
                        </Tag>
                    )}
                </SharedStack>
                <SharedStack row spacing={4}>
                    <SharedStack row>
                        <Icon
                            as={FaEnvelope}
                            fontSize="sm"
                            color={!client.email ? 'gray.400' : 'gray.600'}
                        />
                        <SharedInfoText
                            fontSize="sm"
                            color={!client.email ? 'gray.400' : 'gray.500'}
                        >
                            {formatEmail(client.email) || 'N/A'}
                        </SharedInfoText>
                    </SharedStack>
                    <SharedStack row>
                        <Icon as={FaPhone} fontSize="sm" color="gray.600" />
                        <SharedInfoText whiteSpace="nowrap">
                            {formatPhoneReadable(
                                client.phone,
                                client.address?.country ||
                                    clinic?.address?.country,
                            ) || ''}
                        </SharedInfoText>
                    </SharedStack>
                </SharedStack>
            </Box>
            <Spacer />
            {onCancel && <CloseButton onClick={onCancel} color="gray.500" />}
        </SharedStack>
    )
}
